var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-inline-flex mb-4" }, [
      _vm.movementFields && _vm.movementFields.length
        ? _c("div", { staticClass: "form-check mr-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAll,
                  expression: "selectAll"
                }
              ],
              staticClass: "check form-check-input select-all mt-0",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectAll)
                  ? _vm._i(_vm.selectAll, null) > -1
                  : _vm.selectAll
              },
              on: {
                change: function($event) {
                  var $$a = _vm.selectAll,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectAll = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectAll = $$c
                  }
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "mr-3 mb-0" }, [_vm._v("Movement")]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "span",
          {
            staticClass: "cursor-pointer",
            on: {
              click: function($event) {
                return _vm.addMovement()
              }
            }
          },
          [
            _c("img", {
              staticClass: "heading-icon",
              attrs: { src: require("@/assets/addplus_icon.svg"), width: "20" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isSelected
        ? _c(
            "span",
            {
              staticClass: "cursor-pointer ml-3",
              on: {
                click: function($event) {
                  return _vm.deleteAllMovements()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-trash" })]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      _vm._l(_vm.movementFields, function(item, index) {
        return _c("div", { key: index }, [
          _c(
            "div",
            { staticClass: "fields-wrapper is-divider is-multi-node mb-6" },
            [
              _c("div", { staticClass: "form-check select-single" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.movement.selectSingle,
                      expression: "item.movement.selectSingle"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(item.movement.selectSingle)
                      ? _vm._i(item.movement.selectSingle, null) > -1
                      : item.movement.selectSingle
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = item.movement.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                item.movement,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                item.movement,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(item.movement, "selectSingle", $$c)
                        }
                      },
                      _vm.checkSingleSelect
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-buttons" }, [
                _c(
                  "span",
                  {
                    staticClass: "action-item ",
                    on: {
                      click: function($event) {
                        return _vm.copyMovement(index, item)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-copy" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "action-item",
                    on: {
                      click: function($event) {
                        return _vm.removeMovement(index)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-5 col-form-label" }, [
                        _vm._v("\n                Path Type\n              ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.movement.pathType,
                                expression: "item.movement.pathType"
                              }
                            ],
                            staticClass: "custom-select",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    item.movement,
                                    "pathType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.pathTypeChanged(index)
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "Linear" } }, [
                              _vm._v("Linear")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "CatmullRom" } }, [
                              _vm._v("CatmullRom")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "CubicBezier" } }, [
                              _vm._v("CubicBezier")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-5 col-form-label" }, [
                        _vm._v(
                          "\n                Orientation Type\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.movement.orientationType,
                                expression: "item.movement.orientationType"
                              }
                            ],
                            staticClass: "custom-select",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  item.movement,
                                  "orientationType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "LookAhead" } }, [
                              _vm._v("Look Ahead")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "LookAtTarget" } }, [
                              _vm._v("Look At Target")
                            ]),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "LookAtPosition" } },
                              [_vm._v("Look at Position")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  item.movement.orientationType === "LookAtTarget"
                    ? _c(
                        "div",
                        { staticClass: "row form-group align-items-center" },
                        [
                          _c(
                            "label",
                            { staticClass: "col-sm-5 col-form-label" },
                            [_vm._v("\n                Target\n              ")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-7" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.movement.entityOrientation
                                        .lookAtTarget,
                                    expression:
                                      "item.movement.entityOrientation.lookAtTarget"
                                  }
                                ],
                                staticClass: "custom-select",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      item.movement.entityOrientation,
                                      "lookAtTarget",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.targets, function(target) {
                                return _c(
                                  "option",
                                  {
                                    key: target.objectId,
                                    domProps: { value: target.objectId }
                                  },
                                  [_vm._v(_vm._s(target.name))]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.movement.orientationType === "LookAtPosition"
                    ? _c(
                        "div",
                        { staticClass: "row form-group align-items-center" },
                        [
                          _c(
                            "label",
                            { staticClass: "col-sm-5 col-form-label" },
                            [
                              _vm._v(
                                "\n                Position\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-7" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("span", { staticClass: "p-2" }, [
                                  _vm._v("x")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        item.movement.entityOrientation
                                          .lookAtPosition[0],
                                      expression:
                                        "\n                      item.movement.entityOrientation.lookAtPosition[0]\n                    "
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    id: "destination_position_x"
                                  },
                                  domProps: {
                                    value:
                                      item.movement.entityOrientation
                                        .lookAtPosition[0]
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item.movement.entityOrientation
                                          .lookAtPosition,
                                        0,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "p-2" }, [
                                  _vm._v("y")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        item.movement.entityOrientation
                                          .lookAtPosition[1],
                                      expression:
                                        "\n                      item.movement.entityOrientation.lookAtPosition[1]\n                    "
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    id: "destination_position_y"
                                  },
                                  domProps: {
                                    value:
                                      item.movement.entityOrientation
                                        .lookAtPosition[1]
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item.movement.entityOrientation
                                          .lookAtPosition,
                                        1,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "p-2" }, [
                                  _vm._v("z")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        item.movement.entityOrientation
                                          .lookAtPosition[2],
                                      expression:
                                        "\n                      item.movement.entityOrientation.lookAtPosition[2]\n                    "
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    id: "destination_position_z"
                                  },
                                  domProps: {
                                    value:
                                      item.movement.entityOrientation
                                        .lookAtPosition[2]
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item.movement.entityOrientation
                                          .lookAtPosition,
                                        2,
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-5 col-form-label" }, [
                        _vm._v(
                          "\n                Total duration (sec)\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "number", readonly: "" },
                          domProps: { value: _vm.duration(index) }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("div", { staticClass: "col-sm-5 form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.movement.loopCount,
                              expression: "item.movement.loopCount"
                            }
                          ],
                          attrs: { type: "checkbox", id: "loopCount" },
                          domProps: {
                            checked: Array.isArray(item.movement.loopCount)
                              ? _vm._i(item.movement.loopCount, null) > -1
                              : item.movement.loopCount
                          },
                          on: {
                            change: function($event) {
                              var $$a = item.movement.loopCount,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      item.movement,
                                      "loopCount",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item.movement,
                                      "loopCount",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item.movement, "loopCount", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "col-form-label ml-2" }, [
                          _vm._v("\n                  Loop\n                ")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-5 form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.movement.isSpeedbased,
                              expression: "item.movement.isSpeedbased"
                            }
                          ],
                          attrs: { type: "checkbox", id: "loopCount" },
                          domProps: {
                            checked: Array.isArray(item.movement.isSpeedbased)
                              ? _vm._i(item.movement.isSpeedbased, null) > -1
                              : item.movement.isSpeedbased
                          },
                          on: {
                            change: function($event) {
                              var $$a = item.movement.isSpeedbased,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      item.movement,
                                      "isSpeedbased",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item.movement,
                                      "isSpeedbased",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item.movement, "isSpeedbased", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "col-form-label ml-2" }, [
                          _vm._v(
                            "\n                  Is speed based\n                "
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row form-group align-items-center"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-5 col-form-label" }, [
                        _vm._v(
                          "\n                Rotation speed\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.movement.lookAtValue,
                              expression: "item.movement.lookAtValue"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: item.movement.lookAtValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                item.movement,
                                "lookAtValue",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("div", { staticClass: "d-inline-flex mb-3" }, [
                      _c("h4", { staticClass: "mb-0" }, [_vm._v("Way Points")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center ml-4 mt-0" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.addNewWayPoint(index)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "heading-icon",
                                attrs: {
                                  src: require("@/assets/addplus_icon.svg"),
                                  width: "20"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(item.movement.waypoints, function(point, elem) {
                      return _c(
                        "div",
                        {
                          key: elem,
                          staticClass: "fields-wrapper is-multi-node mb-6"
                        },
                        [
                          _c("div", { staticClass: "action-buttons" }, [
                            _c(
                              "span",
                              {
                                staticClass: "action-item ",
                                on: {
                                  click: function($event) {
                                    return _vm.copyWayPoint(index, point)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-copy" })]
                            ),
                            _vm._v(" "),
                            (item.movement.pathType == "CubicBezier" &&
                              item.movement.waypoints.length > 3) ||
                            (item.movement.pathType != "CubicBezier" &&
                              item.movement.waypoints.length > 1)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteWayPoint(index, elem)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row form-group align-items-center"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "col-sm-5 col-form-label" },
                                [
                                  _vm._v(
                                    "\n                  Start Time (sec)\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: point.startTime,
                                      expression: "point.startTime"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: point.startTime },
                                  on: {
                                    change: function($event) {
                                      return _vm.startTimeChanged(index, elem)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        point,
                                        "startTime",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row form-group align-items-center"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "col-sm-5 col-form-label" },
                                [
                                  _vm._v(
                                    "\n                  End Time (sec)\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: point.endTime,
                                      expression: "point.endTime"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: point.endTime },
                                  on: {
                                    change: function($event) {
                                      return _vm.endTimeChanged(index, elem)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        point,
                                        "endTime",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row form-group align-items-center"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "col-sm-5 col-form-label" },
                                [
                                  _vm._v(
                                    "\n                  Duration (sec)\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: point.duration,
                                      expression: "point.duration"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number", readonly: "" },
                                  domProps: { value: point.duration },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        point,
                                        "duration",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row form-group align-items-center"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "col-sm-5 col-form-label" },
                                [
                                  _vm._v(
                                    "\n                  Point\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("span", { staticClass: "p-2" }, [
                                      _vm._v("x")
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: point.point[0],
                                          expression: "point.point[0]"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        id: "destination_position_x"
                                      },
                                      domProps: { value: point.point[0] },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            point.point,
                                            0,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "p-2" }, [
                                      _vm._v("y")
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: point.point[1],
                                          expression: "point.point[1]"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        id: "destination_position_y"
                                      },
                                      domProps: { value: point.point[1] },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            point.point,
                                            1,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "p-2" }, [
                                      _vm._v("z")
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: point.point[2],
                                          expression: "point.point[2]"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        id: "destination_position_z"
                                      },
                                      domProps: { value: point.point[2] },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            point.point,
                                            2,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e529994", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e529994","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/movement.vue
// module id = null
// module chunks = 